// import variables from '@variables';
import React, { Suspense } from "react";
import { Platform, StyleSheet, View } from "react-native";
import variables from "../../styles/variables";
import { NestedKeyOf } from "../../../utility";
import { deep_value } from "../../utils/deepValue";
import RText from "../RText";
import lazyImport from "../../utils/lazyImport/lazyImport";
import { importIcon } from "./icons";

export type IconSize = keyof typeof variables.sizes;
// export type IconName = keyof typeof IconList;
// export type FlagIcon = keyof typeof FlagList;
export type Colors = typeof variables.colors;
export type IconFill = NestedKeyOf<Colors>;

// todo - convert three digits into 2 digit flag so we can get the flags
// we'll actually use, rather than all

type Props = {
  name: any; //IconName | FlagIcon;
  size?: IconSize;
  fill?: IconFill;
  style?: any;
  rotate?: number;
  notifications?: number;
  stroke?: IconFill;
  color?: Colors;
  onTabar?: boolean;
};

const Icon = ({
  name,
  style,
  size,
  fill,
  rotate,
  notifications = 0,
  stroke,
  color,
  onTabar = false,
  ...rest
}: Props) => {
  // Dynamic import using lazyImport
  const IconComponent = React.useMemo(() => {
    return lazyImport(() => importIcon(name));
  }, [name]);

  if (!IconComponent) return null;

  return (
    <Suspense fallback={<></>}>
      <IconComponent
        style={[
          styles.icon,
          style,
          rotate ? { transform: [{ rotate: `${rotate}deg` }] } : {},
        ]}
        color={color && color}
        fill={fill && deep_value(variables.colors, fill)}
        stroke={stroke && deep_value(variables.colors, stroke)}
        {...(size && variables.sizes[size])}
        {...rest}
      />
      {notifications > 0 && (
        <View
          style={{
            position: "absolute",
            top: onTabar ? 2 : -10,
            right: -10,
            width: 20,
            height: 20,
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#18b8b8",
            borderRadius: 10,
          }}
        >
          {/* <NotificationBadge /> */}
          <RText
            color="white"
            weight="bold"
            size={notifications > 99 ? "xxs" : "xs"}
            style={{ position: "absolute" }}
          >
            {`${notifications}`}
          </RText>
        </View>
      )}
    </Suspense>
  );
};

/* don't add height and width attrs for web */
const styles =
  Platform.OS === "web"
    ? StyleSheet.create({
        icon: {
          userSelect: "none", // stops any nearby text highlighting
        },
      })
    : StyleSheet.create({
        icon: {
          height: "100%",
          width: "100%",
        },
      });

export default React.memo(Icon);
